import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a63a47ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = {
  key: 0,
  class: "combination"
}
const _hoisted_3 = { class: "function" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Key',
  props: {
  keys: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;

const keys = props.keys.split(" + ");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keys), (key, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("span", {
          class: "key",
          textContent: _toDisplayString(key)
        }, null, 8, _hoisted_1),
        (index !== _unref(keys).length - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " + "))
          : _createCommentVNode("", true)
      ], 64))
    }), 256)),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})